/**
 * LotSmith — App root entry.
 *
 * React Router 6 data router. Routes:
 *   /                    Landing
 *   /login               Magic-link login
 *   /verify              Magic-link verification handler
 *   /app                 Dashboard shell (outlet)
 *   /app/account/:id     Per-account detail
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./styles/tokens.css";
import "./styles/typography.css";
import "./styles/base.css";
import "./styles/app.css";

import { Landing } from "./routes/Landing.js";
import { Login } from "./routes/Login.js";
import { Verify } from "./routes/Verify.js";
import { Onboarding } from "./routes/Onboarding.js";
import { Pricing } from "./routes/Pricing.js";
import { LegalPage } from "./routes/LegalPage.js";
import { Status } from "./routes/Status.js";
import { DashboardShell } from "./routes/DashboardShell.js";
import { DashboardHome } from "./routes/DashboardHome.js";
import { AccountDetail } from "./routes/AccountDetail.js";
import { Trades } from "./routes/Trades.js";
import { Calendar } from "./routes/Calendar.js";
import { Settings } from "./routes/Settings.js";
import { NotFound } from "./routes/NotFound.js";

const router = createBrowserRouter([
  { path: "/", element: <Landing /> },
  { path: "/login", element: <Login /> },
  { path: "/verify", element: <Verify /> },
  { path: "/onboarding", element: <Onboarding /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/terms", element: <LegalPage doc="terms" /> },
  { path: "/privacy", element: <LegalPage doc="privacy" /> },
  { path: "/refund", element: <LegalPage doc="refund" /> },
  { path: "/disclaimer", element: <LegalPage doc="disclaimer" /> },
  { path: "/status", element: <Status /> },
  {
    path: "/app",
    element: <DashboardShell />,
    children: [
      { index: true, element: <DashboardHome /> },
      { path: "account/:id", element: <AccountDetail /> },
      { path: "trades", element: <Trades /> },
      { path: "calendar", element: <Calendar /> },
      { path: "settings", element: <Settings /> },
    ],
  },
  { path: "*", element: <NotFound /> },
]);

const rootEl = document.getElementById("app");
if (!rootEl) throw new Error("#app root missing");
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
